var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCakeBoxAutoBottomTemplate = function SvgCakeBoxAutoBottomTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "615.0mm",
    height: "426.8328157299975mm",
    viewBox: "0.0 0.0 615.0 426.8328157299975",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 15,
    y1: 56.83281572999748,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 615,
    x2: 615,
    y1: 0,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    x2: 207,
    y1: 36.83281572999748,
    y2: 36.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 532.1145521850017,
    x2: 550.5,
    y1: 77.64009182249835,
    y2: 86.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 528.9522745248333,
    x2: 552.6277192044965,
    y1: 68.1532588419932,
    y2: 20.802369482666734,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 562.1145521850017,
    x2: 580.5,
    y1: 17.64009182249834,
    y2: 26.832815729997478,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 566.5866881400013,
    x2: 576.0278640450005,
    y1: 31.056499687497066,
    y2: 35.77708763999664,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 542.3686823898321,
    x2: 557.0998551594962,
    y1: 63.68112288699362,
    y2: 34.21877734766544,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 545.5309600500004,
    x2: 554.9721359549995,
    y1: 73.16795586749876,
    y2: 77.88854381999832,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 515.5,
    x2: 550.5,
    y1: 156.8328157299975,
    y2: 86.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 554.9721359549995,
    x2: 576.0278640450005,
    y1: 77.88854381999832,
    y2: 35.77708763999664,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 615,
    x2: 615,
    y1: 156.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 580.5,
    x2: 593.9164078649987,
    y1: 26.832815729997478,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 215,
    y1: 56.83281572999748,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 183,
    x2: 215,
    y1: 156.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 83,
    x2: 147,
    y1: 156.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    x2: 315,
    y1: 156.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 47,
    y1: 156.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 215,
    y1: 156.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 15,
    y1: 156.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 515,
    y1: 156.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 615,
    y1: 156.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 215,
    y1: 56.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 315,
    y1: 156.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    x2: 15,
    y1: 54.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    x2: 15.5,
    y1: 44.83281572999748,
    y2: 54.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 214.5,
    x2: 214.5,
    y1: 44.83281572999748,
    y2: 54.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 214.5,
    x2: 215,
    y1: 54.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 345,
    x2: 347,
    y1: 54.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 345,
    x2: 352,
    y1: 54.83281572999748,
    y2: 36.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 352,
    x2: 376,
    y1: 36.83281572999748,
    y2: 36.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 376,
    x2: 383,
    y1: 36.83281572999748,
    y2: 54.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 383,
    x2: 381,
    y1: 54.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    x2: 347,
    y1: 56.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 381,
    x2: 449,
    y1: 56.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 483,
    x2: 515,
    y1: 56.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    x2: 315,
    y1: 0,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    x2: 82,
    y1: 155.8328157299975,
    y2: 155.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 82,
    x2: 83,
    y1: 155.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 250.5,
    x2: 232.1145521850017,
    y1: 86.83281572999748,
    y2: 77.64009182249835,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 228.9522745248333,
    x2: 252.6277192044966,
    y1: 68.1532588419932,
    y2: 20.80236948266672,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 262.11455218500174,
    x2: 280.5,
    y1: 17.64009182249834,
    y2: 26.832815729997478,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 266.5866881400013,
    x2: 276.0278640450004,
    y1: 31.05649968749708,
    y2: 35.77708763999664,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 242.3686823898321,
    x2: 257.09985515949614,
    y1: 63.68112288699362,
    y2: 34.21877734766544,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 245.53096005000046,
    x2: 254.97213595499957,
    y1: 73.16795586749876,
    y2: 77.88854381999832,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 215.5,
    x2: 250.5,
    y1: 156.8328157299975,
    y2: 86.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 254.97213595499957,
    x2: 276.0278640450004,
    y1: 77.88854381999832,
    y2: 35.77708763999664,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 280.5,
    x2: 293.91640786499875,
    y1: 26.832815729997478,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 384,
    x2: 444,
    y1: 92.83281572999748,
    y2: 122.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 386,
    x2: 446,
    y1: 90.83281572999748,
    y2: 120.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 515,
    y1: 56.83281572999748,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 86,
    x2: 146,
    y1: 90.83281572999748,
    y2: 120.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 84,
    x2: 144,
    y1: 92.83281572999748,
    y2: 122.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 48,
    y1: 156.8328157299975,
    y2: 155.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 250.5,
    x2: 254.97213595499957,
    y1: 86.83281572999748,
    y2: 77.88854381999832,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 276.0278640450004,
    x2: 280.5,
    y1: 35.77708763999664,
    y2: 26.832815729997478,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 576.0278640450005,
    x2: 580.5,
    y1: 35.77708763999664,
    y2: 26.832815729997478,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 550.5,
    x2: 554.9721359549995,
    y1: 86.83281572999748,
    y2: 77.88854381999832,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    x2: 515,
    y1: 155.8328157299975,
    y2: 155.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    x2: 381,
    y1: 56.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 483,
    x2: 485,
    y1: 56.83281572999748,
    y2: 54.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 478,
    x2: 485,
    y1: 36.83281572999748,
    y2: 54.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 478,
    y1: 36.83281572999748,
    y2: 36.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 447,
    y1: 36.83281572999748,
    y2: 54.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 447,
    x2: 449,
    y1: 54.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 148,
    x2: 182,
    y1: 155.8328157299975,
    y2: 155.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 148,
    x2: 147,
    y1: 155.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    x2: 183,
    y1: 155.8328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 449,
    x2: 483,
    y1: 56.83281572999748,
    y2: 56.83281572999748,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 293.91640786499875,
    x2: 315,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 593.9164078649987,
    x2: 615,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 214.5 44.8328 A 8.81 8.81 0 0 0 207 36.8328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 528.9523 68.1533 A 10.08 10.08 0 0 0 532.1146 77.6401"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 562.1146 17.6401 A 10.06 10.06 0 0 0 552.6277 20.8024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 542.3687 63.6811 A 10.08 10.08 0 0 0 545.531 73.168"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 566.5867 31.0565 A 10 10 0 0 0 557.0999 34.2188"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 23 36.8328 A 8.8 8.8 0 0 0 15.5 44.8328"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 228.9523 68.1533 A 10.07 10.07 0 0 0 232.1146 77.6401"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 262.1146 17.6401 A 10 10 0 0 0 252.6277 20.8024"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 242.3687 63.6811 A 10.08 10.08 0 0 0 245.531 73.168"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 266.5867 31.0565 A 10 10 0 0 0 257.0999 34.2188"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 386 90.8328 A 1.51 1.51 0 0 0 384 92.8328"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 444 122.8328 A 1.51 1.51 0 0 0 446 120.8328"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 86 90.8328 A 1.51 1.51 0 0 0 84 92.8328"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 144 122.8328 A 1.49 1.49 0 0 0 146 120.8328"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 205,
    x2: 215,
    y1: 366.8328157299975,
    y2: 376.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 205,
    y1: 376.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    x2: 205,
    y1: 426.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 165,
    x2: 185,
    y1: 406.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 205,
    x2: 165,
    y1: 366.8328157299975,
    y2: 406.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 25,
    y1: 356.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    x2: 100,
    y1: 426.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    x2: 100,
    y1: 411.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    x2: 115,
    y1: 406.8328157299975,
    y2: 411.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 215,
    y1: 356.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    x2: 165,
    y1: 406.8328157299975,
    y2: 406.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    x1: 505,
    x2: 515,
    y1: 366.8328157299975,
    y2: 376.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 505,
    y1: 376.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    x1: 485,
    x2: 505,
    y1: 426.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    x1: 465,
    x2: 485,
    y1: 406.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    x1: 465,
    x2: 505,
    y1: 406.8328157299975,
    y2: 366.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    x2: 325,
    y1: 356.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    x1: 325,
    x2: 400,
    y1: 426.8328157299975,
    y2: 426.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 415,
    y1: 426.8328157299975,
    y2: 411.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    x1: 415,
    x2: 415,
    y1: 406.8328157299975,
    y2: 411.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    x2: 515,
    y1: 356.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    x1: 415,
    x2: 465,
    y1: 406.8328157299975,
    y2: 406.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 235,
    y1: 356.8328157299975,
    y2: 406.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    x1: 235,
    x2: 265,
    y1: 406.8328157299975,
    y2: 406.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    x1: 265,
    x2: 315,
    y1: 406.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 315,
    y1: 356.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 535,
    y1: 356.8328157299975,
    y2: 406.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    x1: 535,
    x2: 565,
    y1: 406.8328157299975,
    y2: 406.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    x1: 565,
    x2: 615,
    y1: 406.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 615,
    y1: 356.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    x1: 214.5,
    x2: 205,
    y1: 356.8328157299975,
    y2: 366.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    x1: 505,
    x2: 514.5,
    y1: 366.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 15,
    y1: 341.8328157299975,
    y2: 356.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 164.3328157299975,
    y2: 341.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 15,
    y1: 164.3328157299975,
    y2: 156.8328157299975,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCakeBoxAutoBottomTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cake-box-auto-bottom-template.1983d4fb.svg";
export { ForwardRef as ReactComponent };